import AppModal from "@/components/AppModal.tsx";
import Security2FA from '@/pages/security/Security2FA';
import { clearTaskRule } from '@/redux/slices/user';
import { useEffect } from "react";

const TwoFAModal = (props) => {
  const { open, onClose, paymentInfo, successCallback } = props;
  useEffect(() => {
    clearTaskRule()
  }, []);
  const callback = () => {
    successCallback && successCallback()
  }

  const _onClose = () => {
    // setTaskId(null);
    // setTaskRuleParams(null);
    onClose?.();
  }

  return (<>
    <AppModal open={open} onClose={_onClose}>
      <Security2FA callback={callback} onClose={onClose}/>
    </AppModal>
  </>)
}

export default TwoFAModal